export class College {
  name: string;
  id: number;
  nk: string;
  city: string;
  state: string;
  address: string;
  display: string;
  created_ts: string;
  has_courses: boolean;
  is_transferable: boolean;

  constructor(college: Partial<College>) {
    _.merge(this, college);
    this.address = College.buildAddress(this.city, this.state);
    this.display = this.address ? `${this.name} - ${this.address}` : this.name;
  }

  static buildAddress(city: string, state: string): string {
    if (_.isEmpty(city)) {
      return '';
    }

    if (_.isEmpty(state)) {
      return city;
    }

    return `${city}, ${state}`;
  }

  static build(college: College): College {
    return new College(college);
  }
}

angular.module('capability-ng-transfer').factory('ngCollegeBuilder', function(): typeof College {
  return College;
});



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/college_builder.ts